import store from "../store";
import { HEADER, HEADER_BG_PROPERTIES, Scroll_Header, SHOW_FIXED_NAV, Show_Header, STREAM, } from "@redux/interfaces/iHeader";
var HeaderActions = /** @class */ (function () {
    function HeaderActions() {
        this.dispatch = store.dispatch;
    }
    HeaderActions.prototype.getMenuData = function (headerEntityList) {
        return {
            type: HEADER,
            payload: {
                data: headerEntityList,
            },
        };
    };
    HeaderActions.prototype.getStreamData = function (payload) {
        this.dispatch({
            type: STREAM,
            payload: {
                stream: payload,
            },
        });
    };
    HeaderActions.prototype.getMarketData = function (payload) {
        this.dispatch({
            type: STREAM,
            payload: {
                stream: payload,
            },
        });
    };
    HeaderActions.prototype.RemoveHeaderData = function (showHeader) {
        this.dispatch({
            type: Show_Header,
            payload: { showHeader: showHeader },
        });
    };
    HeaderActions.prototype.setScrollHeader = function (scrollHeader) {
        this.dispatch({
            type: Scroll_Header,
            payload: { scrollHeader: scrollHeader },
        });
    };
    HeaderActions.prototype.HideFixedNavMob = function (showFixedNavMob) {
        this.dispatch({
            type: SHOW_FIXED_NAV,
            payload: { showFixedNavMob: showFixedNavMob },
        });
    };
    HeaderActions.prototype.headerBG_Properties = function (properties) {
        this.dispatch({
            type: HEADER_BG_PROPERTIES,
            payload: { headerBG_Properties: properties },
        });
    };
    return HeaderActions;
}());
export default HeaderActions;
